import { Box, DialogContent, DialogTitle } from "@mui/material";
import { orderItemBusiness } from "api/bussiness/order/order-item-business";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IUpdateStatus } from "mobx-stores/_models/orders/order-item";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getUpdateStatusSchema } from "../schema";

export const OrderStatusManagement = observer(() => {
  const {
    orderManagement: {
      openManageStatus,
      setProp,
      selectedOrderItem,
      getOrderDetail,
      orderDetail,
    },
    catalogueStore: {
      orderStatuses,
      getOrderStatuses,
      cataloguesToOptionItems,
    },
  } = useStores();

  const {
    form: { controls, isValid },
    getControl,
    setDefaults,
    submitHandler,
  } = useForm<IUpdateStatus>(getUpdateStatusSchema(), {
    id: "",
    deliveredQuantity: 0,
    statusId: "",
  });
  const onCloseHandler = useCallback(() => {
    setProp("openManageStatus", false);
    setProp("selectedOrderItem", null);
  }, [setProp]);

  useEffect(() => {
    if (selectedOrderItem) {
      setDefaults({
        id: selectedOrderItem.id,
        deliveredQuantity: selectedOrderItem.deliveredQuantity || 0,
        statusId: selectedOrderItem.statusId,
      });
    }
  }, [selectedOrderItem, setDefaults]);

  useEffect(() => {
    getOrderStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (orderStatuses) {
      getControl("statusId").setProp(
        "optionItems",
        cataloguesToOptionItems(orderStatuses)
      );
    }
  }, [cataloguesToOptionItems, getControl, orderStatuses]);

  const saveHandler = useCallback(
    async (data: IUpdateStatus) => {
      try {
        if (!selectedOrderItem?.id) return;
        await orderItemBusiness.manageItemStatus(selectedOrderItem?.id, data);
        if (orderDetail?.id) {
          await getOrderDetail(orderDetail?.id);
        }
        onCloseHandler();
      } catch (ex) {
        console.error(ex);
      }
    },
    [getOrderDetail, onCloseHandler, orderDetail?.id, selectedOrderItem?.id]
  );
  return (
    <DialogForm
      open={openManageStatus}
      fullWidth
      maxWidth={"sm"}
      onClose={onCloseHandler}
      onCancelBtnClicked={onCloseHandler}
      onSaveBtnClick={async () => {
        await submitHandler(saveHandler);
      }}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>{`Cập nhật trạng thái mặt hàng - ${selectedOrderItem?.product?.name}`}</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
